module.exports = __webpack_public_path__ + "media/images/right_show_sidebar/ic_comment-cbadf6833cebdfb2168dcd0506430426.png";